import axios, { AxiosInstance } from "axios";

const defaultCallApiTimeout = 1000 * 30;

const client: AxiosInstance = axios.create({
  baseURL: `${window.location.origin}/api`,
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
  },
  timeout: defaultCallApiTimeout,
});

export default client;
